import { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase/config";

export default function useForgot() {
    const [error, setError] = useState(null);
    const [isPending, setIsPending] = useState(false);
  
    // Reset error state
    const resetError = () => setError(null);

      // Forgot Password
  const forgotPassword = async (email) => {
    setError(null);
    setIsPending(true);
    try {
      await sendPasswordResetEmail(auth, email);
      return true;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setIsPending(false);
    }
  };
  return {
    forgotPassword,
    error,
    isPending,
    resetError
  }
}
